import { MaxWidth, ResponsiveService } from './responsive.service';
import { Transition, TransitionService } from '@uirouter/angular';
import { Injector } from '@angular/core';

/**
 * @ngdoc method
 * @name ga2.shared.services:responsiveService#widthSwitcherInitializer
 * @methodOf ga2.shared.services:responsiveService
 * @description
 * Sets the main container width through route data configuration using parameter 'noMaxWidth'
 */
export function widthSwitcherInitializer(injector:Injector) {
  return () => {
    const transitionService:TransitionService = injector.get(TransitionService);
    const responsiveService:ResponsiveService = injector.get(ResponsiveService);

    transitionService.onSuccess({}, switchMaxWidth);

    function switchMaxWidth(transition:Transition):void {
      // when noMaxWidth: true -> use MEDIUM as maximum width
      // when noMaxWidth is undefined -> use the existing width if available, otherwise use MINIMUM as default
      responsiveService.width = transition.to()?.data?.noMaxWidth ? MaxWidth.MD : responsiveService.width || MaxWidth.SM;
    }
  };
}